import React from 'react';
import {PropTypes} from 'prop-types';
import {BaseFormComponent} from '../../shared/baseFormComponent';
import {ErrorsBlockComponent} from '../../shared/errorsBlockComponent';
import {ButtonBusyIndicatorComponent} from '../../shared/buttonBusyIndicatorComponent';
import {SetFocusOnFirstFormControl, AssignProperties, GoToUrlOrRoot, DisplaySuccessMessage, MakeApiCall, PreventDOMLock} from '../../shared/utils';

const RESET_ACTION = {
    NONE: 0,
    RESET: 1
}

class ResetPasswordFormComponent extends BaseFormComponent {
    constructor(props, ...others) {
        super(props, ...others);
        this.strings = {...this.constructor.defaultProps.strings};
        AssignProperties(this.strings, props.strings);

        this.state = {
            action: RESET_ACTION.NONE,
            errors: null, 
            formData: {NewPassword: '', ReNewPassword: ''}
        };
        this.doReset = this.doReset.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        const self = this;
        self._isMounted = true;
        if (Boolean(self.props.isSetFocus)) {
            SetFocusOnFirstFormControl(self, true);
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleSubmit(event) {
        event.preventDefault();
        const self = this;

        PreventDOMLock(self.doReset);
    }

    doReset() {
        const self = this;
        const {resetPasswordApiUrl, verificationToken} = self.props;

        if (!Boolean(resetPasswordApiUrl) || !self._isMounted) {
            return;
        }

        const data = {Email: self.props.email, ResetKey: self.props.resetKey, ...self.state.formData};

        new Promise(resolve => {
            self.setState({action: RESET_ACTION.RESET, errors: null}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return MakeApiCall(
                    $.post(
                        {
                            url: resetPasswordApiUrl,
                            headers: {RequestVerificationToken: verificationToken},
                            data: data,
                            dataType: 'json',
                            cache: false
                        }
                    ));
            }
        })
        .then(responseData => {
            if (self._isMounted) {
                DisplaySuccessMessage(responseData.SuccessMessage);
                GoToUrlOrRoot(responseData.SuccessUrl);
            }
        })
        .catch(errors => {
            if (self._isMounted) {
                self.setState({action: RESET_ACTION.NONE, errors: errors});
            }
        });
    }

    render() {
        const self = this;
        const {email, userName} = self.props;
        const {action, errors, formData} = self.state;
        const isDisabled = action !== RESET_ACTION.NONE;
        const strings = self.strings;

        return (
            <div>
                <div className="text-center">
                    <ErrorsBlockComponent errors={errors} unstyled excludedErrors="NewPassword ReNewPassword"/>
                </div>
                <div className="row">
                    <div className="m-auto col-xl-5 col-lg-6 col-md-8 col-sm-10">
                        <form onSubmit={self.handleSubmit}>
                            {Boolean(userName) &&
                                <div className="form-group newstyle">
                                    <div className="input-group" readOnly>
                                        <input 
                                            type="text" 
                                            id="userName"
                                            name="UserName" 
                                            readOnly
                                            className="form-control"
                                            value={userName} 
                                        />
                                        <div className="input-group-append">
                                            <span className="input-group-text"><span className="sbkico-user"/></span>
                                        </div>
                                        <label htmlFor="userName"><span className="text-truncate">{strings.F_Name}</span></label>
                                    </div>
                                </div>
                            }
                            <div className="form-group newstyle">
                                <div className="input-group" readOnly>
                                    <input 
                                        type="text" 
                                        id="email"
                                        name="Email" 
                                        readOnly
                                        className="form-control"
                                        value={email} 
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text"><span className="sbkico-envelope"/></span>
                                    </div>
                                    <label htmlFor="email"><span className="text-truncate">{strings.F_Email}</span></label>
                                </div>
                            </div>
                            <div className="form-group newstyle">
                                <div className={'input-group ' + self.getControlClass('NewPassword', errors)} disabled={isDisabled} >
                                    <input 
                                        type="password" 
                                        id="newPassword"
                                        name="NewPassword" 
                                        autoComplete="new-password"
                                        onChange={self.handleInputChange}
                                        className={'form-control ' + self.getControlClass('NewPassword', errors)} 
                                        value={formData.NewPassword} 
                                        disabled={isDisabled} 
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text"><span className="sbkico-lock"/></span>
                                    </div>
                                    <label htmlFor="newPassword"><span className="text-truncate">{strings.F_NewPassword}</span></label>
                                    <div className="invalid-feedback">{self.getControlError('NewPassword', errors)}</div>
                                </div>
                            </div>
                            <div className="form-group newstyle">
                                <div className={'input-group ' + self.getControlClass('ReNewPassword', errors)} disabled={isDisabled} >
                                    <input 
                                        type="password" 
                                        id="reNewPassword"
                                        name="ReNewPassword" 
                                        autoComplete="new-password"
                                        onChange={self.handleInputChange}
                                        className={'form-control ' + self.getControlClass('ReNewPassword', errors)} 
                                        value={formData.ReNewPassword} 
                                        disabled={isDisabled} 
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text"><span className="sbkico-lock"/></span>
                                    </div>
                                    <label htmlFor="reNewPassword"><span className="text-truncate">{strings.F_ReNewPassword}</span></label>
                                    <div className="invalid-feedback">{self.getControlError('ReNewPassword', errors)}</div>
                                </div>
                            </div>
                            <div className="form-group form-buttons">
                                <button 
                                    type="submit" 
                                    className="btn btn-primary newstyle" 
                                    disabled={isDisabled}
                                >
                                    {strings.BTN_SaveNewPassword}<ButtonBusyIndicatorComponent visible={action == RESET_ACTION.RESET} />
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );    
    }
}
ResetPasswordFormComponent.propTypes = {
    strings: PropTypes.object,
    verificationToken: PropTypes.string.isRequired,
    isSetFocus: PropTypes.bool,
    email: PropTypes.string.isRequired,
    userName: PropTypes.string,
    resetKey: PropTypes.string.isRequired,
    resetPasswordApiUrl: PropTypes.string.isRequired
}
ResetPasswordFormComponent.defaultProps = {
    strings: {
        F_Name: 'Name',
        F_Email: 'Email',
        F_NewPassword: 'New Password',
        F_ReNewPassword: 'Re-type New Password',
        BTN_SaveNewPassword: 'Save new password'
    },
    isSetFocus: false,
    userName: ''
}

export {ResetPasswordFormComponent};